(() => {
  const root = document.querySelector('[data-gv-track]');
  if (!root) return;

  const form = root.querySelector('[data-gv-track-form]');
  const result = root.querySelector('[data-gv-track-result]');
  const errorEl = root.querySelector('[data-gv-track-error]');
  const apiUrl = (root.dataset.apiUrl || '').trim();
  const accountUrl = root.dataset.accountUrl || '/account';
  const submitBtn = root.querySelector('[data-gv-track-submit]');

  function showError(msg) {
    if (!errorEl) return;
    errorEl.hidden = !msg;
    errorEl.textContent = msg || '';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderOrder(order) {
    if (!result) return;
    const tracking = order.tracking;
    const items = order.items || [];
    const timeline = order.timeline || [];

    result.hidden = false;
    result.innerHTML = `
      <div class="gv-tr__card">
        <div class="gv-tr__card-top">
          <div>
            <p class="gv-tr__card-kicker">Order ${escapeHtml(order.name)}</p>
            <h2>${escapeHtml(order.fulfillment_status)}</h2>
            <p class="gv-tr__muted">Payment · ${escapeHtml(order.financial_status)}</p>
          </div>
          ${
            order.status_page_url
              ? `<a class="gv-btn" href="${escapeHtml(order.status_page_url)}" target="_blank" rel="noopener">Full order status</a>`
              : ''
          }
        </div>

        <ol class="gv-tr__timeline">
          ${timeline
            .map(
              (step) => `
            <li class="${step.done ? 'is-done' : ''}">
              <span></span>
              <strong>${escapeHtml(step.label)}</strong>
            </li>`
            )
            .join('')}
        </ol>

        ${
          tracking?.number
            ? `<div class="gv-tr__ship">
                <h3>Shipment</h3>
                <p><strong>${escapeHtml(tracking.company || 'Carrier')}</strong> · ${escapeHtml(tracking.number)}</p>
                ${
                  tracking.url
                    ? `<a class="gv-btn gv-btn--ghost" href="${escapeHtml(tracking.url)}" target="_blank" rel="noopener">Track parcel</a>`
                    : `<a class="gv-btn gv-btn--ghost" href="https://t.17track.net/en#nums=${encodeURIComponent(tracking.number)}" target="_blank" rel="noopener">Track parcel</a>`
                }
              </div>`
            : `<div class="gv-tr__ship gv-tr__ship--wait">
                <h3>Shipment</h3>
                <p>Your parcel isn’t with the carrier yet. You’ll get tracking by email once it ships (usually within 2–5 business days).</p>
              </div>`
        }

        ${
          items.length
            ? `<div class="gv-tr__items">
                <h3>Items</h3>
                <ul>
                  ${items
                    .map(
                      (item) => `
                    <li>
                      ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" width="48" height="48">` : '<span class="gv-tr__ph"></span>'}
                      <div>
                        <strong>${escapeHtml(item.title)}</strong>
                        <small>Qty ${escapeHtml(item.quantity)}</small>
                      </div>
                    </li>`
                    )
                    .join('')}
                </ul>
              </div>`
            : ''
        }
      </div>
    `;
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  async function lookupViaApi(orderNumber, email) {
    const endpoint = apiUrl.replace(/\/$/, '');
    const urls = endpoint.endsWith('/track') ? [endpoint] : [endpoint, `${endpoint}/track`];
    let lastErr = 'Lookup failed.';

    for (const url of urls) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ order_number: orderNumber, email }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          lastErr = data.error || lastErr;
          continue;
        }
        if (data.order) {
          renderOrder(data.order);
          return true;
        }
      } catch (e) {
        lastErr = 'Could not reach the tracking service.';
      }
    }
    showError(lastErr);
    return false;
  }

  function fallbackWithoutApi(orderNumber, email) {
    if (!result) return;
    result.hidden = false;
    result.innerHTML = `
      <div class="gv-tr__card">
        <p class="gv-tr__card-kicker">Next step</p>
        <h2>Open your Glowvelle order status</h2>
        <p class="gv-tr__muted">We found your details for order <strong>#${escapeHtml(orderNumber)}</strong> (${escapeHtml(email)}). Shopify keeps the live tracking page secure — sign in or use the link from your confirmation email.</p>
        <div class="gv-tr__actions">
          <a class="gv-btn" href="${escapeHtml(accountUrl)}" target="_blank" rel="noopener">View my orders</a>
          <a class="gv-btn gv-btn--ghost" href="/pages/contact">Need help?</a>
        </div>
        <ol class="gv-tr__howto">
          <li>Open your Glowvelle order confirmation email</li>
          <li>Tap <strong>View order status</strong></li>
          <li>If asked, confirm with this order number and email</li>
        </ol>
      </div>
    `;
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    showError('');
    if (result) result.hidden = true;

    const fd = new FormData(form);
    const orderNumber = String(fd.get('order_number') || '')
      .trim()
      .replace(/^#/, '');
    const email = String(fd.get('email') || '')
      .trim()
      .toLowerCase();

    if (!orderNumber || !email) {
      showError('Enter both order number and email.');
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Looking up…';
    }

    try {
      if (apiUrl) {
        await lookupViaApi(orderNumber, email);
      } else {
        fallbackWithoutApi(orderNumber, email);
      }
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.label || 'Track order';
      }
    }
  });

  // Tracking number shortcut
  const trackNumForm = root.querySelector('[data-gv-carrier-form]');
  trackNumForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const input = trackNumForm.querySelector('input[name="tracking_number"]');
    const num = String(input?.value || '').trim();
    if (!num) return;
    window.open(`https://t.17track.net/en#nums=${encodeURIComponent(num)}`, '_blank', 'noopener');
  });
})();
